import * as url from 'url';
import { makeImageLink } from './image';
import { routeToString } from './route';
export function getBusinessJsonLd(business) {
    return {
        '@context': 'http://schema.org',
        '@type': 'LocalBusiness',
        ...business,
    };
}
export function makeArticleJsonLd(entity, { imageHost, rootUrl, title, data }) {
    const images = [
        entity.image,
        ...(Array.isArray(entity.images) ? entity.images : []),
    ]
        .filter(Boolean)
        .map(image => image && makeImageLink({ image, host: imageHost }))
        .filter(Boolean);
    return {
        '@context': 'https://schema.org',
        '@type': 'Article',
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': rootUrl,
        },
        headline: entity.title,
        image: images,
        datePublished: entity.publishedAt,
        dateModified: entity.updatedAt,
        author: entity.author && {
            '@type': 'Person',
            name: entity.author.title,
        },
        publisher: {
            '@type': 'Organization',
            name: title,
            logo: {
                '@type': 'ImageObject',
                url: makeImageLink({ host: imageHost, image: data.logo }),
            },
        },
        description: entity.description,
    };
}
export function makeProductJsonLd(entity, { imageHost, routesMap, rootUrl }) {
    const images = [
        entity.image,
        ...(Array.isArray(entity.images) ? entity.images : []),
    ]
        .filter(Boolean)
        .map(image => makeImageLink({ image, host: imageHost }))
        .filter(Boolean);
    const path = routeToString({ name: 'product', params: { slug: entity.slug } }, routesMap);
    const link = rootUrl ? url.resolve(rootUrl, path) : path;
    return {
        '@context': 'http://www.schema.org',
        '@type': 'Product',
        brand: entity.brands &&
            entity.brands.length > 0 &&
            entity.brands.map(x => x.title),
        name: entity.title,
        image: images,
        description: entity.description,
        // aggregateRating: {
        //   '@type': 'aggregateRating',
        //   ratingValue: '5',
        //   reviewCount: '21',
        // },
        offers: entity.salePrice && entity.salePrice.amount
            ? {
                '@type': 'Offer',
                priceCurrency: entity.salePrice.currency,
                price: entity.salePrice.amount,
                priceValidUntil: '2020-12-31',
                url: link,
                itemCondition: 'https://schema.org/NewCondition',
                availability: 'https://schema.org/InStock',
            }
            : undefined,
    };
}
//# sourceMappingURL=jsonld.js.map